import { CREATE_REPORT } from '../constants/report';

export function createReport(data) {
  return {
    type: CREATE_REPORT,
    api: true,
    auth: true,
    payload: {
      method: 'POST',
      url: '/students/reports',
      data
    }
  };
}
